import { createContext } from 'react';

export interface RedirectContextValue {
  redirectUrl: string | null;
  setRedirectUrl: (url: string | null) => void;
  handleClose: () => void;
}

export const RedirectContext = createContext<RedirectContextValue | undefined>(undefined);
